import React from 'react';
import './SessionRoster.css';
import { getAgeInYearsAndMonths } from '../utils';
import { updateKidData } from '../api/coach';

const SessionRoster = ({ session, onChange }) => {
  if (!session || !session.roster) {
    return null;
  }

  const handleAttendanceChange = async (kidId, isPresent) => {
    try {
      await updateKidData(session.id, kidId, isPresent, '')
      const updatedRoster = session.roster.map(kid =>
        kid.kidId === kidId ? { ...kid, attended: isPresent } : kid
      );
      if (onChange) {
        onChange({
          ...session,
          roster: updatedRoster
        });
      }
    } catch (error) {
      console.error('Error updating attendance:', error);
    }
  };

  const attendedCount = session.roster.filter(kid => kid.attended).length;

  return (
    <div className="roster-container">
      <div className="roster-header">
        <span className="roster-header-label">Attendance</span>
        <span className="roster-header-count">{attendedCount} of {session.roster.length}</span>
      </div>

      <div className="roster-list">
        {session.roster.map((kid, index) => {
          const { years, months } = getAgeInYearsAndMonths(kid.dob)
          return (
            <div key={`${kid.id}-${index}`} className="roster-item">
              <input
                type="checkbox"
                className="roster-checkbox"
                checked={kid.attended}
                onChange={(e) => handleAttendanceChange(kid.kidId, e.target.checked)}
              />
              <div className="roster-kid-info">
                <span className="kid-name">{kid.firstName} {kid.lastName}</span>
                <span className="kid-age">{years}y {months}mo</span>
              </div>
              {kid.contactPhone && (
                <a href={`tel:${kid.contactPhone}`} className="phone-link" aria-label="Call parent">
                  📞
                </a>
              )}
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default SessionRoster;